import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { track as _track } from '../../actions/tracking';

import { parsers } from '../../helpers';
import { getItem } from '../../selectors/item';
import { getItemRetailerPhoneParams } from '../../selectors/item-retailer';
import { getRetailerTelephone, isRetailerUsingFreespee } from '../../selectors/retailer';
import { conversionEvents, eventTypes } from '../../shared/tracking';
import { phonenumbers } from '../../utils';

const BranchTelephone = () => {
  const dispatch = useDispatch();
  const telephoneNumber = useSelector(getRetailerTelephone);
  const item = useSelector(getItem);
  const phoneParams = useSelector(getItemRetailerPhoneParams);
  const usingPhoneNumberGeneration = useSelector(isRetailerUsingFreespee);
  const track = bindActionCreators(_track, dispatch);

  const [visiblePhoneNumber, setVisiblePhoneNumber] = useState<string | undefined>();
  const [showTelephone, setShowTelephone] = useState(false);
  const { t } = useTranslation('item');

  if (!telephoneNumber) return null;

  const phonenumber = parsers.parsePhoneNumber(telephoneNumber);
  if (!phonenumber?.e164 || !phonenumber.international) return null;
  const phonenumberE164 = phonenumber.e164;
  const phonenumberInternational = phonenumber.international;

  const displayPhonenumber = () => {
    if (usingPhoneNumberGeneration) {
      phonenumbers.convert(phonenumberInternational, phoneParams, (generated) => {
        const parsed = parsers.parsePhoneNumber(generated);
        setVisiblePhoneNumber(parsed.e164);
      });
    } else {
      setVisiblePhoneNumber(phonenumberE164);
    }

    track(eventTypes.CONVERSION, {
      item,
      conversionType: conversionEvents.CONVERSION_PHONENUMBER_VISIBLE,
      information: { context: 'retailer' },
    });
    setShowTelephone(true);
  };

  const { e164, national } = parsers.parsePhoneNumber(visiblePhoneNumber);
  return (
    <li className="detail-list-item">
      <div className="detail-list-item-cell">
        <div className="detail-list-label">{t('Phone number', { ns: 'item' })}</div>
      </div>
      <div className="detail-list-item-cell">
        <div className="detail-list-value">
          {showTelephone ? (
            <a
              href={e164}
              title={t('Call phone number', { ns: 'item', number: national })}
              data-am-link=""
            >
              {national}
            </a>
          ) : (
            <button
              type="button"
              data-am-link=""
              onClick={displayPhonenumber}
              title={t('Show phone number', { ns: 'item' })}
            >
              {t('Show phone number', { ns: 'item' })}
            </button>
          )}
        </div>
      </div>
    </li>
  );
};

export default BranchTelephone;
